module.exports = __webpack_public_path__ + "static/media/eduspot-logo.da5cf1bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/eduspot-logo.svg
// module id = 720
// module chunks = 0